import { CellWithBg } from "../purchasing/CellWithBg";
import { green, orange, red } from "@mui/material/colors";
import { jsx as _jsx } from "react/jsx-runtime";
export function RestockStatus() { return { name: "Status", width: 50, filter: (row, value) => { if (value.toLowerCase() === "ok") {
        return row.qty >= row.stockMinQty;
    } if (value.toLowerCase() === "low") {
        return row.qty < row.idealQty;
    } if (value.toLowerCase() === "reorder") {
        return row.qty < row.stockMinQty;
    } return true; }, render: data => { let name = "Ok"; let color = "white"; let bgColor = green["500"]; if (data.qty < data.stockMinQty || data.warnReorder) {
        bgColor = red["500"];
        name = "Reorder";
    }
    else if (data.qty < data.idealQty || data.warnLow) {
        bgColor = orange["500"];
        name = "Low";
    } return /*#__PURE__*/ _jsx(CellWithBg, { color: color, backgroundColor: bgColor, children: name }); } }; }
